
import { api } from "../api";

/**
 * identifierFindAllCrudResponse - Function that finds on database all drivers identifiers as crud response data    
 * /identifiers/{status}   
 * method GET 
 * @async-function
 */
const identifierFindAllCrudResponse = async (token: string, managerId: number, status: string, page: number, size: number, search: string = "") => {
    const response = await api.get(
        `/identifiers/${managerId}/${status}?page=${page}&size=${size}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default identifierFindAllCrudResponse;